import axios from "axios";
import Cookies from "universal-cookie";
import { createBrowserHistory } from "history";
import { Slide, ToastContainer, toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-toastify/dist/ReactToastify.css";
import loadingSvg from "../assets/loading.svg";
import { v4 as uuidv4 } from "uuid";
import config from "../appConfig";
import { QuestionInterFace } from "../interfaces/QuestionInterface";
import Question from "../components/Question/Question";
import MeetingHeader from "../components/MeetingHeader/MeetingHeader";
import { useNavigate, useParams } from "react-router-dom";
import { CallToAction } from "../interfaces/CallToAction";

type objType = {
  [key: string]: number;
};

const cookies = new Cookies();
const history = createBrowserHistory();
function getMobileOperatingSystem(): string {
  const userAgent: string =
    navigator.userAgent || navigator.vendor || (window as any).opera;

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return config["FEEDBACK-UI-APPSTORE-URL"];
  }
  // Android detection
  else if (/android/i.test(userAgent)) {
    return config["FEEDBACK-UI-PLAYSTORE-URL"];
  }

  return config["FEEDBACK-UI-APPSTORE-URL"];
}
function RatingPage() {
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showNotFoundError, setShowNotFoundError] = useState(false);
  const [showGenericError, setShowGenericError] = useState(false);
  const [showAlreadySubmittedError, setShowAlreadySubmittedError] =
    useState(false);
  const [showExpiredError, setShowExpiredError] = useState(false);
  const [showInputActivityCodeError, setShowInputActivityCodeError] =
    useState(false);
  const [questions, setQuestions] = useState<any[]>([]);
  const [inputValue, setInputValue] = useState("");
  const [eventName, setEventName] = useState("");
  const [description, setDescription] = useState("");
  const [avatar, setAvatar] = useState("");
  const [activityType, setActivityType] = useState("");
  const [activityDateTime, setActivityDateTime] = useState("");
  const [firstName, setFirstName] = useState("");
  const [loading, setLoading] = useState(false);
  const [lastName, setLastName] = useState("");
  const [ratings, setRatings] = useState<objType>({});
  const [feedbackCount, setfeedbackCount] = useState("");
  const [activityCount, setactivityCount] = useState("");
  const [verificationRequired, setVerificationRequired] = useState(false);
  const [verified, setVerified] = useState(false);
  const [email, setEmail] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [verificationToken, setVerificationToken] = useState('');
  const [perpetualFeedback, setPerpetualFeedback] = useState(false);
  const [level, setlevel] = useState("");
  const [enableGenericFeedback, setEnableGenericFeedback] = useState(false);
  const [useCustomCallToAction, setUseCustomCallToAction] = useState(false);
  const [callToActions, setCallToActions] = useState<CallToAction[]>([]);
  const [genericFeedback, setGenericFeedback] = useState('');
  const [showGenericFeedback, setShowGenericFeedback] = useState(false);
  const [progress, setProgress] = useState<number>(0);
  const { activityCode } = useParams();
  const isData = activityCode && eventName;
  const navigate = useNavigate();
  const [guid] = useState(uuidv4);
  useEffect(() => {
    if (activityCode) {
      hideAllBoxMessages();
      setLoading(true);
      axios
        .get(
          `${config.KATA_LIFE_API_URL}feedback/${activityCode}/${config["FEEDBACK-UI-QUESTION-COUNT"]}`
        )
        .then((data) => {
          const isVerificationRequired = data?.data?.verification === 2 || data?.data?.verification === 3;
          const isPerpetualFeedback = data?.data?.perpetualFeedback ?? false;

          // Check if already submitted (but allow if verification required or perpetual feedback)
          let activityCodes = cookies.get("activityCodes");
          if (activityCodes && activityCodes.includes(activityCode) && !isPerpetualFeedback && !isVerificationRequired) {
            setShowAlreadySubmittedError(true);
            setLoading(false);
            return;
          }

          setEventName(data?.data?.eventName);
          setQuestions(data?.data?.questions || []);
          setFirstName(data?.data?.firstName);
          setLastName(data?.data?.lastName);
          setDescription(data?.data?.description);
          setActivityType(data?.data?.activityType);
          setActivityDateTime(data?.data?.activityDateTime);
          setAvatar(data?.data?.avatar);
          setfeedbackCount(data?.data?.feedbackCount);
          setactivityCount(data?.data?.activityCounts);
          setlevel(data?.data?.level);
          setVerificationRequired(isVerificationRequired);
          setPerpetualFeedback(isPerpetualFeedback);
          setEnableGenericFeedback(data?.data?.enableGenericFeedback ?? false);
          setUseCustomCallToAction(data?.data?.useCustomCallToAction ?? false);
          setCallToActions(data?.data?.callToActions || []);
        })
        .catch((error) => {
          //history.push("/");
          if (error.response?.status === 422) {
            setShowExpiredError(true);
          } else if (error.response?.status === 404) {
            setShowNotFoundError(true);
          } else {
            setShowGenericError(true);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [activityCode]);

  function submitRatings(data: any) {
    let activityCodes = cookies.get("activityCodes");
    if (activityCodes) {
      // Allow submission if perpetual feedback is enabled OR verification is required (email verified)
      if (activityCodes.includes(activityCode) && !perpetualFeedback && !verificationRequired) {
        setShowAlreadySubmittedError(true);
        return false;
      } else {
        activityCodes = [...activityCodes, activityCode];
      }
    } else {
      activityCodes = [activityCode];
    }
    activityCodes = JSON.stringify(activityCodes);
    setLoading(true);

    axios
      .post(`${config.KATA_LIFE_API_URL}feedback`, {
        SessionId: guid,
        Answers: data,
        ActivityCode: activityCode,
        Email: email
      })
      .then((response) => {
        cookies.set("activityCodes", activityCodes, { path: "/" });
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  }

  function handleRateChange(rating: number, id: string) {
    const currentIndex = questions.findIndex((item) => item.questionId === id);
    const oldRatings: objType = { ...ratings };
    oldRatings[`${questions[currentIndex].questionId}`] = rating;
    setRatings({ ...oldRatings });

    // Start progress bar
    setProgress(0);
    const duration = 1000; // Total duration in ms
    const interval = 50; // Update every 50ms
    const steps = duration / interval;
    const increment = 100 / steps;

    let currentProgress = 0;
    const progressInterval = setInterval(() => {
      currentProgress += increment;
      if (currentProgress >= 100) {
        setProgress(100);
        clearInterval(progressInterval);
        setTimeout(() => setProgress(0), 100);
      } else {
        setProgress(currentProgress);
      }
    }, interval);

    setTimeout(() => {
      if (currentIndex + 1 < questions.length) {
        setActiveQuestionIndex(currentIndex + 1);
      } else {
        submitRatings(oldRatings);
        if (enableGenericFeedback) {
          setShowGenericFeedback(true);
        } else {
          setShowConfirmation(true);
        }
      }
      clearInterval(progressInterval);
      setProgress(0);
    }, duration);
  }

  function hideAllBoxMessages() {
    setShowAlreadySubmittedError(false);
    setShowExpiredError(false);
    setShowGenericError(false);
    setShowNotFoundError(false);
    setShowInputActivityCodeError(false);
  }

  function handleSubmitGenericFeedback() {
    setLoading(true);
    axios
      .post(`${config.KATA_LIFE_API_URL}feedback/generic`, {
        ActivityCode: activityCode,
        GenericFeedback: genericFeedback,
      })
      .then(() => {
        setShowGenericFeedback(false);
        setShowConfirmation(true);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to submit feedback. Please try again.");
      })
      .finally(() => setLoading(false));
  }

  function handleSkipGenericFeedback() {
    setShowGenericFeedback(false);
    setShowConfirmation(true);
  }

  function handleCtaClick(type: number) {
    axios
      .post(`${config.KATA_LIFE_API_URL}feedback/${activityCode}/cta-click`, {
        SessionId: guid,
        Type: type,
      })
      .catch(() => {});
  }

  function handleSendOtp() {
    axios
      .post(`${config.KATA_LIFE_API_URL}feedback/send-otp`, { email })
      .then((res) => {
        toast.success("OTP sent successfully.");
        setOtpSent(true);
        setVerificationToken(res.data.token);
      })
      .catch(() => {
        toast.error("Failed to send OTP. Please check your email.");
      });
  }
  function handleVerifyOtp() {
    axios
      .post(`${config.KATA_LIFE_API_URL}feedback/verify-otp`, {
        email,
        otp,
        token: verificationToken,
      })
      .then(() => {
        toast.success("Email verified successfully.");
        setVerified(true);
      })
      .catch(() => {
        toast.error("Invalid OTP. Please try again.");
      });
  }
  function renderVerification() {
    return (
      <div className="card mt-3 card-shadow mx-3 messagebox verification-box">
        <div className="full-center-container">
          <div className="card-body text-center card-body-verify">
            <p className="question-title text-center">
              This feedback requires us to verify you.
            </p>

            {!otpSent ? (
              <>
                <div className="green-text">
                  <p>
                    Your email will not be associated to this feedback, or will not be used for any other purpose other than to verify that this feedback is unique and from a valid source.
                  </p>
                </div>
                <input
                  type="email"
                  className="form-control mt-2 mb-2"
                  value={email}
                  id="email"
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  autoComplete="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  required
                />
                <button
                  className="custom-btn custom-btn--center custom-btn--verify"
                  onClick={handleSendOtp}
                  disabled={!email}
                >
                  VERIFY
                </button>
              </>
            ) : (
              <>
                <p>We have sent a 4-digit OTP to <b>{email}</b></p>
                <input
                  type="text"
                  className="form-control mt-2 mb-2"
                  maxLength={4}
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter 4 digit OTP"
                />
                <button
                  className="custom-btn custom-btn--center custom-btn--verify"
                  onClick={handleVerifyOtp}
                  disabled={otp.length !== 4}
                >
                  VALIDATE OTP
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  function getWordCount(text: string): number {
    return text.trim() ? text.trim().split(/\s+/).length : 0;
  }

  function handleGenericFeedbackChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    const text = e.target.value;
    const wordCount = getWordCount(text);
    if (wordCount <= 75) {
      setGenericFeedback(text);
    }
  }

  function renderGenericFeedback() {
    const wordCount = getWordCount(genericFeedback);
    const isOverLimit = wordCount >= 75;

    return (
      <div className="card mt-3 card-shadow mx-3 messagebox generic-feedback-box">
        <div className="card-body text-center">
          <p className="question-title text-center">
            Do you have any additional feedback?
          </p>
          <p className="text-muted mb-3">
            Share your thoughts, suggestions, or comments (optional)
          </p>
          <textarea
            className="generic-feedback-textarea"
            rows={5}
            value={genericFeedback}
            onChange={handleGenericFeedbackChange}
            placeholder="Type your feedback here..."
          />
          <p className={`word-counter ${isOverLimit ? 'word-counter--limit' : ''}`}>
            {wordCount}/75 words
          </p>
          <div className="feedback-buttons">
            <button
              className="custom-btn custom-btn--center custom-btn--skip"
              onClick={handleSkipGenericFeedback}
            >
              Skip
            </button>
            <button
              className="custom-btn custom-btn--center custom-btn--submit"
              onClick={handleSubmitGenericFeedback}
              disabled={!genericFeedback.trim()}
            >
              Submit Feedback
            </button>
          </div>
        </div>
      </div>
    );
  }
  function renderQuestions() {
    return questions?.length > 0 ? (
      <>
        <Carousel
          swipeable={false}
          showArrows={false}
          showThumbs={false}
          showStatus={false}
          useKeyboardArrows={false}
          selectedItem={activeQuestionIndex}
        >
          {questions.map((item: QuestionInterFace, index: number) => (
            <Question
              key={index}
              ratings={ratings}
              question={item.questionText}
              questionId={item.questionId}
              onRateChange={handleRateChange}
            />
          ))}
        </Carousel>
        <div style={{ height: '40px', marginTop: '-10px' }}>
          {progress > 0 && (
            <div className="progress-bar-container">
              <div
                className="progress-bar-fill"
                style={{ width: `${progress}%` }}
              />
            </div>
          )}
        </div>
      </>
    ) : (
      <></>
    );
  }

  function renderConfirmation() {
    const currentRating = ratings ? Object.values(ratings).reduce((a: number, b: number) => a + b, 0) / Object.values(ratings).length : 0;
    const callToAction = callToActions.find(cta => currentRating >= cta.triggerMin && currentRating <= cta.triggerMax);

    if (useCustomCallToAction && callToActions.length > 0) {
      if (callToAction) {
        if (callToAction.type === 1) {
          // Google Review
          return (
            <div className="card mt-3 card-shadow mx-3 messagebox">
              <div className="card-body text-center" style={{ display: "flex", flexWrap: "wrap" }}>
                <br />
                <div className="center activity-card middle" style={{ minWidth: "150px" }}>
                  <img src="/images/google_g_icon.png" alt="Google Logo" style={{ width: "150px", height: "150px" }} />
                </div>
                <div className="center activity-card middle">
                  <span style={{ fontWeight: "lighter" }} className="input-label">{callToAction.message}</span>
                  <br />
                  <br />
                  <button className="custom-btn custom-btn--center">
                    <a
                      className="downloadApp"
                      href={callToAction.targetLink}
                      target="_blank"
                      onClick={() => handleCtaClick(callToAction.type)}
                    >
                      {callToAction.targetLinkText}
                    </a>
                  </button>
                </div>
              </div>
            </div>
          );
        } else if (callToAction.type === 2) {
          // Open Link
          return (
            <div className="card mt-3 card-shadow mx-3 messagebox">
              <div className="card-body text-center">
                <br />
                <div className="center activity-card middle">
                  <span style={{ fontWeight: "lighter" }} className="input-label">{callToAction.message}</span>
                  <br />
                  <br />
                  <button className="custom-btn custom-btn--center">
                    <a
                      className="downloadApp"
                      href={callToAction.targetLink}
                      target="_blank"
                      onClick={() => handleCtaClick(callToAction.type)}
                    >
                      {callToAction.targetLinkText}
                    </a>
                  </button>
                </div>
              </div>
            </div>
          );
        } else if (callToAction.type === 3) {
          // Message
          return (
            <div className="card mt-3 card-shadow mx-3 messagebox">
              <div className="card-body text-center">
                <br />
                <div className="center activity-card middle">
                  <span className="input-label">{callToAction.message}</span>
                  <br />
                  <br />
                </div>
              </div>
            </div>
          );
        }
      }
    }
    else {
      return (
        <div className="card mt-3 card-shadow mx-3 messagebox">
          <div className="card-body text-center">
            <br />
            <div className="center activity-card middle">
              <span className="input-label">Thank you for your feedback.</span>
              <br />
              <br />

            </div>
          </div>
        </div>
      );
    }
  }

  function renderBoxMessage(message: string, canClose: boolean) {
    return (
      <div className="card mt-3 card-shadow mx-3 messagebox">
        {canClose ? (
          <a href="/" className="close" onClick={hideAllBoxMessages}></a>
        ) : (
          ""
        )}
        <div className="card-body text-center">
          <div className="center activity-card">
            <span className="input-label">{message}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <main>
      <section>
        <div className="container-fluid">
          <div className="card-body-carousel">
            {showAlreadySubmittedError
              ? renderBoxMessage(
                config["FEEDBACK-UI-ALREADY-SUBMITTED-MESSAGE"],
                true
              )
              : ""}
            {showExpiredError
              ? renderBoxMessage(config["FEEDBACK-UI-EXPIRED-MESSAGE"], true)
              : ""}
            {showNotFoundError
              ? renderBoxMessage(config["FEEDBACK-UI-NOTFOUND-MESSAGE"], true)
              : ""}
            {showGenericError
              ? renderBoxMessage(config["FEEDBACK-UI-ERROR-MESSAGE"], true)
              : ""}
            {showInputActivityCodeError
              ? renderBoxMessage(
                config["FEEDBACK-UI-INPUT-VALIDATION-MESSAGE"],
                true
              )
              : ""}
            {loading ? (
              <div className="loading-container">
                <img src={loadingSvg} alt="Loading..." className="loadingSvg" />
              </div>
            ) : (
              <>
                {isData && (
                  <MeetingHeader
                    text={eventName}
                    lastName={lastName}
                    firstName={firstName}
                    description={description}
                    activityType={activityType}
                    activityDateTime={activityDateTime}
                    avatar={avatar}
                    feedbackCount={feedbackCount}
                    activityCount={activityCount}
                    level={level}
                    isPerpetual={perpetualFeedback}
                  />
                )}
                {showConfirmation
                  ? renderConfirmation()
                  : showGenericFeedback
                    ? renderGenericFeedback()
                    : verificationRequired && !verified
                      ? renderVerification()
                      : renderQuestions()}
              </>
            )}
          </div>
          <ToastContainer />
          <div className="card-body-carousel" style={{textAlign: "center", marginTop: "20px", marginBottom: "20px"}}>
            Create your own free surveys with KataLife.{" "}
            <a className="navgreen"
              href={"https://kata.life"}
              target="_blank"
              rel="noreferrer"
            >
              Get started now.
            </a>
              
          </div>
        </div>

      </section>
    </main>
  );
}

export default RatingPage;
